import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { SharedModule } from '../shared/shared.module';
import { AuthenticationComponent } from './authentication/authentication.component';
import { socialLoginConfig } from './login-social.config';
import { LoginFacebookComponent } from './login-social/login-facebook/login-facebook.component';
import { LoginGoogleComponent } from './login-social/login-google/login-google.component';
import { LoginComponent } from './login.component';
import { LoginGuard } from './login.guard';
import { LoginService } from './login.service';
import { LoginStorage } from './login.storage';
import { SelectAgenteComponent } from './select-agente/select-agente.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalAceleraMaisComponent } from '../shared/components/modal-acelera-mais/modal-acelera-mais.component';
import { ModalEloGroupComponent } from '../shared/components/modal-elo-group/modal-elo-group.component';
import { AuthRedirectComponent } from './auth-redirect/auth-redirect.component';

export function provideConfig() {
  return socialLoginConfig;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    SocialLoginModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    LoginComponent,
    LoginFacebookComponent,
    LoginGoogleComponent,
    AuthenticationComponent,
    SelectAgenteComponent,
    AuthRedirectComponent,
  ],
  exports: [
    LoginComponent,
    LoginFacebookComponent,
    LoginGoogleComponent,
    AuthenticationComponent,
    SelectAgenteComponent,
  ],
  providers: [
    LoginService,
    LoginGuard,
    LoginStorage,
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: provideConfig,
    },
  ],
  entryComponents: [ModalAceleraMaisComponent, ModalEloGroupComponent],
})
export class LoginModule {}
